import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'

export const TEXT_DE = {
  title: <>Das Pandora-Quartett</>,
  lead: (
    <>
      Könige, Präsidenten, Premiers und ihre Liebsten. 16 Politgrössen, deren
      geheime Briefkastenfirmen in den Pandora Papers aufgetaucht sind, geordnet
      als handliches Kartenset.
    </>
  ),
  updated: <>Aktualisiert am 3. Oktober 2021</>,
  credits: ['Recherche und Text', 'Umsetzung'],
  intro: (
    <>
      <p>
        In einem Bericht des Bundes steht es schwarz auf weiss: Politische
        Persönlichkeiten und ihre Familien, die Vermögen offshore verstecken,
        gelten als «besonders hohes Risiko». Der Grund: Gerade in autoritären
        Staaten haben die politischen Eliten oft Zugriff auf Staatsvermögen, das
        eigentlich den Menschen des Landes gehört.
      </p>
      <p>
        Jetzt tauchen in den Pandora Papers plötzlich riesige Vermögen von über
        300 Politikern und Amtspersonen auf. Bei vielen haben Schweizer Berater
        beim Verstecken geholfen. Offshore-Firmen sind im Prinzip nichts
        Illegales, es kommt immer auf die Umstände an. Woher kommen diese
        Vermögen? Und weshalb liegen sie in Briefkastenfirmen verborgen?
      </p>
      <p>
        Hier 16 wichtige Fälle, geordnet als Quartett. (Tipp: Wer ein echtes
        Quartett möchte, kann die Karten auf{' '}
        <Link href='https://nteraktiv.tagesanzeiger.ch/2021/pandora-quartett/Pandora_Quartett.pdf'>
          diesem PDF.
        </Link>{' '}
        ausdrucken und ausschneiden.)
      </p>
    </>
  ),
  titleA: 'Könige und Präsidenten',
  titleB: 'Premiers und Minister',
  titleC: 'Es bleibt in der Familie',
  titleD: 'Die Powerplayer',
  textA: (
    <p>
      35 amtierende oder ehemalige Staatschefs aus Europa, Asien, Afrika und
      Südamerika werden in den Dokumenten der Pandora Papers genannt. Viele von
      ihnen haben bei ihrem Amtsantritt Bescheidenheit und Transparenz
      versprochen.
    </p>
  ),
  textB: (
    <p>
      Sie verwalten gewaltige Budgets des Staatshaushalts, sie kontrollieren die
      Steuereinnahmen, sie vergeben Subventionen: In den Pandora Papers werden
      über 300 Politiker, Politikerinnen sowie hohe Beamte als Begünstigte von
      vermögenden Offshore-Firmen genannt.
    </p>
  ),
  textC: (
    <p>
      Manchmal geht es um riesige Familienclans, manchmal nur um eine einzige
      Geliebte. Die Dokumente der Pandora Papers zeigen, dass sich mächtige
      Männer häufig auch um eine mächtige Verwandtschaft kümmern müssen.
    </p>
  ),
  textD: (
    <p>
      Die 14 Finanzdienstleister aus den Pandora Papers hatten nicht nur
      Prominente als Kunden. Auch politische Berater, Sportfunktionäre,
      Vizeminister liessen Offshore-Firmen gründen. Der Vorteil der zweiten
      Reihe: Sie steht nur sehr selten im Rampenlicht.
    </p>
  )
}
